import Settings from "utils/CarrotConfig"

export const getEmployeeEditLink = (employeeId: string): string => {
  return `${Settings.CARROT_BACKEND_ADMIN_URL}/Admin/Employees/Edit/Employee/${employeeId}`
}

export const getEmployeeExpensesLink = (employeeId: string): string => {
  return `${Settings.CARROT_BACKEND_ADMIN_URL}/Admin/Employees/${employeeId}/Expenses`
}

export const getEmployeeAllCarrotPlansLink = (employeeId: string): string => {
  return `/employees/${employeeId}/carrot-plans`
}

export const getPlanReviewLink = (employeeId: string): string => {
  return `/employees/${employeeId}/carrot-plans/create-plan/review`
}

export const getCreatePlanLink = (employeeId: string): string => {
  return `/employees/${employeeId}/carrot-plans/create-plan`
}
